import {
    Button,
    Container,
    CssBaseline,
    makeStyles,
    TextField,
    Typography,
    Input,
    InputAdornment,
    InputLabel,
    IconButton,
    FormControl,
    Grid,
    List,
    ListItem,
    Box,
    createGenerateClassName,
} from '@material-ui/core';
import { COLORS } from '../Theme';

import React, { Fragment, useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { SIcon } from '../Icon';

import { useCookies } from 'react-cookie';
import { useSnackbar } from 'notistack';
import ToastStr from '../../request/toastStr';
import '../css/modal.css';
import map from './subAdminMap';

import axios from 'axios';
import {
    admin as v_admin,
    basic,
    Values,
    SNACKBAR_TIME,
} from '../../request/values';
import MapContainer from './subAdminMap';

import DaumPostcode from 'react-daum-postcode';
import ReactDom from 'react-dom';
//const SERVER = basic.server;

const useStyles = makeStyles((theme) => ({
    nanumSquare_regular: {
        fontFamily: 'NanumR',
    },
    background: {
        width: '100vw',
        height: '100vh',
        background: `url("/images/background.png")`,
    },
    content: {
        width: '100%',
        height: '100%',
        display: 'grid',
        //gridTemplateColumns: '230px 1fr',
    },
    mainPage: {
        display: 'grid',
        gridTemplateRows: '1.5fr 5fr',
    },
    title: {
        margin: '5vh 0px 0px 35px',
        fontFamily: 'NanumR',
        fontSize: '1.5rem',
        fontWeight: 'bold',
        display: 'flex',
        gap: '10vw',
    },
    logo: {
        display: 'flex',
        flexWrap: 'wrap',
        alignItems: 'stretch',
        //border: 'solid white',
        margin: '5vh 0px',
        borderWidth: '0px 0px 1px 0px',
        //cursor: 'pointer',
        '& img': {
            width: '30px',
            maxHeight: '50%',
            height: '30px',
            margin: '12px 5px 0px 9%',
        },
        '& #name': {
            display: 'inline-block',
            margin: '10px 0px 0px 0px',
            width: 'calc(91% - 35px)',
            fontFamily: 'NanumR',
            fontSize: '1.5rem',
            fontWeight: 'bolder',
        },
        '& #welcome': {
            display: 'block',
            margin: '5px 0px 0px 9%',
            fontFamily: 'NanumR',
            fontSize: '1.2rem',
        },
    },
    userinfo: {
        display: 'flex',
        justifyContent: 'center',
        flexDirection: 'column',
        alignItems: 'center',
        border: 'none',
        borderWidth: '0px 0px 1px 0px',
        paddingBottom: '0.5vh',
        '& #name': {
            display: 'inline-block',
            fontFamily: 'NanumR',
            fontSize: '1.25rem',
            fontWeight: 'bolder',
        },
    },
    menu: {
        display: 'grid',
        border: 'none',
        borderWidth: '0px 0px 1px 0px',
        fontFamily: 'NanumR',
        fontSize: '1.5rem',
        fontWeight: 'bold',
        '&::after': {
            content: '""',
            position: 'absolute',
            width: '0',
            height: '0',
            left: '50%',
            bottom: '0',
            borderBottom: '3px solid black',
            transition: 'width 0.3s ease, left 0.3s ease',
            WebkitTransition: 'width 0.3s ease, left 0.3s ease',
        },
        '&:hover::after': {
            width: '100%',
            left: '0',
        },
        '&:hover': {
            backgroundColor: 'transparent', // hover 배경색 제거
        },
    },
    navigator: {
        display: 'grid',
        gridTemplateColumns: '1fr 2fr',
        marginTop: '1%',
        //fontSize: '5vw',
        //backgroundColor: `${COLORS.WHITE}`,
    },
    subTitle: {
        minWidth: '10vw',
        display: 'flex',
        flexDirection: 'column',
    },
    menuOpen: {
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        alignItems: 'center',
        marginTop: '10px',
        gap: '10px',
        '& a': {
            margin: '5px',
            fontSize: '1rem',
            width: 'fit-content',
            height: '100%',
            cursor: 'pointer',
            textAlign: 'center',
            position: 'relative',
            '&::after': {
                content: '""',
                position: 'absolute',
                display: 'inline-block',
                width: '0',
                height: '0',
                left: '50%',
                bottom: '-5px',
                borderBottom: '2px solid black',
                transition: 'width 0.3s ease, left 0.3s ease',
                WebkitTransition: 'width 0.3s ease, left 0.3s ease',
            },
            '&:hover::after': {
                width: '100%',
                left: '0',
            },
        },
    },
    menuClose: {
        display: 'none',
    },
    classList: {},
    createClass: {
        padding: '5px 25px',
        margin: '7px 7px',
        width: '100%',
        color: `${COLORS.WHITE}`,
        borderRadius: '10px',
        backgroundColor: `${COLORS.WATER_BLUE}`,
        '&:hover': {
            color: `${COLORS.WATER_BLUE}`,
        },
    },
    table: {
        display: 'grid',
        gridTemplateRows: '1fr 7fr 1fr 7fr 1.5fr',
        width: '40vw',
        height: '60vh',
        margin: '1% auto',
        border: 'none',
        borderRadius: '10px',
        backgroundColor: `${COLORS.WHITE}`,
        '& #downInfo': {
            border: 'none',
        },
    },
    tableTitle: {
        display: 'flex',
        alignItems: 'center',
        width: '40vw',
        padding: '5px 15px',
        border: 'solid lightgray',
        borderWidth: '0 0 1px 0',
    },
    titleName: {
        fontSize: 'inherit',
        fontWeight: 'bold',
        color: `${COLORS.SLATE_GREY}`,
    },
    tableInfo: {
        display: 'grid',
        gridTemplateRows: '10px 1fr 1fr 1fr 10px',
        width: '40vw',
        border: 'none',
        //borderWidth: '0 0 2px 0',
        '& #interest': {
            gridTemplateColumns: '1fr 1fr 1fr',
            gap: '0 15px',
        },
        '& input': {
            //borderColor: 'black',
            //borderRadius: '10px',
            width: '100%',
            paddingLeft: '7px',
            outline: 'none',
            maxHeight: '50px',
        },
        '& select': {
            maxHeight: '50px',
            padding: '5px',
            //fontFamily: 'Nanumgothic',
            appearance: 'none',
        },
        '& #codeContainer': {
            display: 'grid',
            gridTemplateColumns: '2.5fr 1fr',
            '& #classCode': {},
            '& #classPlace': {},
        },
    },
    checkInput: {
        //borderColor: 'black',
        //borderRadius: '10px',
        maxHeight: '50px',
    },
    nonInput: {
        background: 'lightgray',
        color: 'gray',
        maxHeight: '50px',
    },
    checkBtn: {
        maxHeight: '50px',
        width: '100%',
        borderRadius: '10px',
        margin: '0 7px',
        color: `${COLORS.WHITE}`,
        fontSize: '0.9vw',
        backgroundColor: `${COLORS.PUMPKIN}`,
        '&:hover': {
            color: `${COLORS.PUMPKIN}`,
        },
    },
    nonBtn: {
        maxHeight: '50px',
        width: '100%',
        borderRadius: '10px',
        margin: '0 7px',
        color: `${COLORS.WHITE}`,
        fontSize: '0.8vw',
        backgroundColor: 'lightgray',
        '&:hover': {
            cursor: 'default',
            //color: `${COLORS.WHITE}`,
            backgroundColor: 'lightgray',
        },
    },
    infoContainer: {
        padding: '5px 30px',
        display: 'grid',
        width: '40vw',
        gridTemplateRows: '30px 1fr',
    },
    buttonContainer: {
        display: 'grid',
        gridTemplateColumns: '2.5fr 1fr',
        padding: '0 30px',
    },
    classInfo: {
        display: 'grid',
        gridTemplateColumns: '3fr 4fr 8fr 3fr',
        padding: '25px 0',
        backgroundColor: `${COLORS.LIGHT_GREY}`,
    },
    selectBox: {
        boxShadow: '0px 0px 5px -2px',
        maxHeight: '50px',
        position: 'relative',
        width: '100%',
        height: '100%',
        appearance: 'textfield',
    },
    select: {
        width: 'inherit',
        height: 'inherit',
        background: 'transparent',
        border: '0 none',
        outline: '0 none',
        padding: '0 5px',
        position: 'relative',
        zIndex: 3,
    },
    arrowIcon: {
        position: 'absolute',
        // backgroundColor: `${COLORS.WATER_BLUE}`,
        top: '0',
        right: '0',
        zIndex: 1,
        width: '40px',
        height: 'inherit',
        borderLeft: '1px solid lightgray',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        '& img': {
            width: '50%',
        },
    },
    buttonLabel: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        color: `${COLORS.CHARCHOAL_GREY}`,
        fontSize: 18,
        fontFamily: 'NanumB',
        fontWeight: 'bold',
        lineHeight: '21px',
    },
    searchAddr: {
        borderWidth: 2,
        borderStyle: 'solid',
        borderColor: `${COLORS.CHARCHOAL_GREY}`,
        backgroundColor: `${COLORS.PUMPKIN}`,
        borderRadius: '10px',
        margin: '0.5vh',
        width: '15vw',
        height: '45vh',
    },
    classVer: {
        display: 'flex',
        flexDirection: 'row',
        gap: '10px',
    },
}));

const SERVER = basic.server;
const { kakao } = window;

export interface propsType {
    searchKeyword: string;
}

const SubAdminCreateClass: React.FC<any> = (props) => {
    const classes = useStyles();

    const { member } = props;
    const [classCode, setClassCode] = useState<any | null>();
    const [className, setClassName] = useState<any | null>();
    const [classVersion, setClassVersion] = useState<any | null>('2');
    const [classPlace, setClassPlace] = useState<any | null>();
    const [initStock, setInitStock] = useState<any | null>('10000');
    const [maxLoan, setMaxLoan] = useState<any | null>('20000');
    const [interest, setInterest] = useState<any | null>('2');
    const [interestTime, setInterestTime] = useState<any | null>('5');
    const [interestHms, setInterestHms] = useState<any | null>('분');
    const [auth, setAuth] = useState<boolean>(false);
    const [modalOpen, setModalOpen] = useState<boolean>(false);
    const [clicked, setflag] = useState<boolean>(true);
    const [codevalidate, setflags] = useState<boolean>(true);
    const [menu, setMenu] = useState<boolean>(false);
    const [operMenu, setOperMenu] = useState<boolean>(false);

    const history = useHistory();

    const [cookies, setCookie, removeCookie] = useCookies();
    const { enqueueSnackbar, closeSnackbar } = useSnackbar();

    const classCodeCheck = () => {
        //setAuth((prevState) => true);
        let url = new URL(SERVER + v_admin.admin + v_admin.auth_class_info);
        let params = {
            classCode: classCode ? classCode.toString().trim() : '',
            action: 'join',
        };
        url.search = new URLSearchParams(params).toString();

        axios({
            method: 'GET',
            withCredentials: true,
            url: url.toString(),
        })
            .then((res) => {
                return res.data;
            })
            .then((data: any) => {
                console.log(data);
                if (data.code == Values.SUCCESS_CODE) {
                    enqueueSnackbar(ToastStr.CLASS_CODE_DUPLICATION, {
                        variant: 'warning',
                        autoHideDuration: SNACKBAR_TIME,
                    });
                } else if (data.code == Values.FAIL_CODE) {
                    // this is success == dont exist same id
                    enqueueSnackbar(ToastStr.CLASS_AUTH_SUCCESS_STR, {
                        variant: 'success',
                        autoHideDuration: SNACKBAR_TIME * 2,
                    });
                    setAuth((prevState) => true);
                    setflags(false);
                    document
                        .getElementById('classCode')
                        ?.setAttribute('readonly', 'readonly');
                }
            });
    };
    const handleButton = (e: any) => {
        if (auth) {
            enqueueSnackbar(ToastStr.CLASS_AUTH_SUCCESS_STR, {
                variant: 'success',
                autoHideDuration: SNACKBAR_TIME,
            });
            setflags(false);
            document
                .getElementById('classCode')
                ?.setAttribute('readonly', 'readonly');
        } else {
            // setAnimation(true);
            if (classCode == null)
                enqueueSnackbar(ToastStr.CLASS_CODE_CHECK_STR, {
                    variant: 'warning',
                    autoHideDuration: SNACKBAR_TIME,
                });
            else classCodeCheck();
        }
    };

    const valueChangeHandler = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { id, value } = e.target;

        if (id == 'classCode') setClassCode(value);
        else if (id == 'className') setClassName(value);
        else if (id == 'classPlace') setClassPlace(value);
        else if (id == 'initStock') setInitStock(value);
        else if (id == 'maxLoan') setMaxLoan(value);
        else if (id == 'interest') setInterest(value);
        else if (id == 'interestTime') setInterestTime(value);
        else if (id == 'interestHms') setInterestHms(value);
    };

    const valueChangeHandler2 = (e: React.ChangeEvent<HTMLSelectElement>) => {
        const { value } = e.target;
        setInterestHms(value);
    };

    const valueChangeHandler3 = (e: React.ChangeEvent<HTMLSelectElement>) => {
        const { value } = e.target;
        setClassVersion(value);
    };

    const classCreate = (event: any) => {
        if (!auth)
            enqueueSnackbar(ToastStr.CHECK_VALIDATE_CODE_STR, {
                variant: 'warning',
                autoHideDuration: SNACKBAR_TIME,
            });
        else if (
            isNaN(initStock) ||
            isNaN(maxLoan) ||
            isNaN(interest) ||
            isNaN(interestTime)
        )
            enqueueSnackbar(ToastStr.CHECK_MONEY_INFO_STR, {
                variant: 'warning',
                autoHideDuration: SNACKBAR_TIME,
            });
        else {
            axios({
                method: 'POST',
                data: {
                    classCode: classCode,
                    className: className,
                    classVersion: classVersion,
                    classPlace: classPlace,
                    initStock: initStock,
                    maxLoan: maxLoan,
                    interest: interest,
                    interestTime: interestTime,
                    interestHms: interestHms,
                    email: member.id,
                },
                withCredentials: true,
                url: SERVER + v_admin.admin + v_admin.create,
            })
                .then((res) => {
                    return res.data;
                })
                .then((data: any) => {
                    console.log(data);
                    console.log(data.code);
                    if (data.code == Values.SUCCESS_CODE) {
                        enqueueSnackbar(ToastStr.CLASS_CREATE_SUCCESS_STR, {
                            variant: 'success',
                            autoHideDuration: SNACKBAR_TIME,
                        });
                        history.push({
                            pathname: '/subadminClasslist',
                        });
                    } else {
                        if (data.code == Values.FAIL_CODE) {
                            enqueueSnackbar(ToastStr.CLASS_CREATE_FAIL_STR, {
                                variant: 'warning',
                                autoHideDuration: SNACKBAR_TIME,
                            });
                        } else {
                            enqueueSnackbar(
                                ToastStr.REQUEST_GET_POST_FAIL_STR,
                                {
                                    variant: 'error',
                                    autoHideDuration: SNACKBAR_TIME,
                                }
                            );
                        }
                    }
                });
        }
    };

    const moveClassList = () => {
        history.push('/subAdminClassList');
    };
    const moveClassManage = () => {
        history.push('/subAdminClassManage');
    };
    const moveOperList = () => {
        history.push('/subAdminOperList');
    };
    const openModal = () => {
        setModalOpen(true);
    };
    const closeModal = () => {
        setModalOpen(false);
    };
    const getAddress = (address: any) => {
        document.getElementById('classPlace')?.setAttribute('value', address);
        document
            .getElementById('classPlace')
            ?.setAttribute('readonly', 'readonly');
        setClassPlace(address);
        setflag(false);
        // document.getElementById("classPlace")?.style.background = lightgray;
    };
    const nothing = () => {};

    return (
        <div className={classes.background}>
            <CssBaseline />
            <div className={classes.content}>
                <div className={classes.mainPage}>
                    <div className={classes.navigator}>
                        <div className={classes.logo}>
                            <img src="/images/p.webp"></img>
                            <Typography id="name">플레이스타트업</Typography>
                            <Typography id="welcome">
                                {member.name}님, 환영합니다!
                            </Typography>
                        </div>
                        <div className={classes.title}>
                            <div
                                className={classes.subTitle}
                                onMouseOver={() => {
                                    setMenu(true);
                                }}
                                onMouseOut={() => {
                                    setMenu(false);
                                }}
                            >
                                <Button
                                    className={classes.menu}
                                    onClick={() => moveClassList()}
                                >
                                    교육
                                </Button>
                                <div
                                    className={
                                        menu
                                            ? classes.menuOpen
                                            : classes.menuClose
                                    }
                                >
                                    <a onClick={(e) => moveClassList()}>
                                        교육 목록
                                    </a>
                                    <a onClick={(e) => moveClassManage()}>
                                        교육 관리 목록
                                    </a>
                                </div>
                            </div>
                            <div
                                className={classes.subTitle}
                                onMouseOver={() => {
                                    setOperMenu(true);
                                }}
                                onMouseOut={() => {
                                    setOperMenu(false);
                                }}
                            >
                                <Button
                                    className={classes.menu}
                                    onClick={() => moveOperList()}
                                >
                                    강사
                                </Button>
                                <div
                                    className={
                                        operMenu
                                            ? classes.menuOpen
                                            : classes.menuClose
                                    }
                                >
                                    <a onClick={(e) => moveOperList()}>
                                        강사 관리
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className={classes.classList}>
                        <div className={classes.table}>
                            <div className={classes.tableTitle}>
                                <Typography className={classes.titleName}>
                                    교육 정보 입력
                                </Typography>
                            </div>
                            <div className={classes.tableInfo}>
                                <div></div>
                                <div className={classes.infoContainer}>
                                    <Typography>클래스 코드</Typography>
                                    <div id="codeContainer">
                                        <input
                                            type="text"
                                            id="classCode"
                                            className={
                                                codevalidate
                                                    ? classes.checkInput
                                                    : classes.nonInput
                                            }
                                            onChange={valueChangeHandler}
                                        ></input>
                                        <Button
                                            id="codeValidate"
                                            className={
                                                codevalidate
                                                    ? classes.checkBtn
                                                    : classes.nonBtn
                                            }
                                            onClick={
                                                codevalidate
                                                    ? handleButton
                                                    : nothing
                                            }
                                        >
                                            <Typography>
                                                코드 중복 체크
                                            </Typography>
                                        </Button>
                                    </div>
                                </div>
                                <div className={classes.infoContainer}>
                                    <div className={classes.classVer}>
                                        <Typography style={{ flex: 1 }}>
                                            교육명
                                        </Typography>
                                        <Typography style={{ flex: 1 }}>
                                            교육 버전
                                        </Typography>
                                    </div>
                                    <div className={classes.classVer}>
                                        <input
                                            type="text"
                                            id="className"
                                            placeholder="유스타터중학교(안규리님)"
                                            onChange={valueChangeHandler}
                                        ></input>
                                        <div className={classes.selectBox}>
                                            <select
                                                className={classes.select}
                                                onChange={valueChangeHandler3}
                                            >
                                                <option value="1">
                                                    1 (라이센스 3개)
                                                </option>
                                                <option value="2" selected>
                                                    2 (라이센스 6개)
                                                </option>
                                                <option value="3">
                                                    3 (라이센스 9개)
                                                </option>
                                                <option value="4">
                                                    4 (라이센스 6개+가격조정)
                                                </option>
                                                <option value="5">
                                                    5 (라이센스 9개+가격조정)
                                                </option>
                                            </select>
                                            <span className={classes.arrowIcon}>
                                                <img src="/images/down_blue.webp"></img>
                                            </span>
                                        </div>
                                    </div>
                                </div>
                                <div className={classes.infoContainer}>
                                    <Typography>교육 장소</Typography>
                                    <div id="codeContainer">
                                        <input
                                            type="text"
                                            id="classPlace"
                                            readOnly
                                            className={
                                                clicked
                                                    ? classes.checkInput
                                                    : classes.nonInput
                                            }
                                            onClick={
                                                clicked ? openModal : nothing
                                            }
                                        ></input>

                                        <Button
                                            id="searchAddr"
                                            className={
                                                clicked
                                                    ? classes.checkBtn
                                                    : classes.nonBtn
                                            }
                                            onClick={
                                                clicked ? openModal : nothing
                                            }
                                        >
                                            <Typography>주소 검색</Typography>
                                        </Button>
                                    </div>
                                    <Modal
                                        open={modalOpen}
                                        close={closeModal}
                                        header="Search_Map"
                                        getAddress={getAddress}
                                    />

                                    {/*
                                    <Button id="searchPlace" onClick={openModal}>
                                        <Typography>
                                            주소 검색
                                        </Typography>
                                    </Button>
                                    <Modal2 open={modalOpen} close={closeModal} header="Search_Add" getAddress = {getAddress} >
                                        hihi
                                    </Modal2>
                                    */}
                                </div>
                            </div>
                            <div className={classes.tableTitle}>
                                <Typography className={classes.titleName}>
                                    자금 정보 입력
                                </Typography>
                            </div>
                            <div className={classes.tableInfo} id="downInfo">
                                <div></div>
                                <div className={classes.infoContainer}>
                                    <Typography>기업 초기 자본금</Typography>
                                    <input
                                        type="text"
                                        id="initStock"
                                        onChange={valueChangeHandler}
                                        defaultValue="10000"
                                    ></input>
                                </div>
                                <div className={classes.infoContainer}>
                                    <Typography>최대 대출 금액</Typography>
                                    <input
                                        type="text"
                                        id="maxLoan"
                                        onChange={valueChangeHandler}
                                        defaultValue="20000"
                                    ></input>
                                </div>
                                <div
                                    className={classes.infoContainer}
                                    id="interest"
                                >
                                    <Typography>이자율</Typography>
                                    <Typography>이자 주기</Typography>
                                    <Typography>단위 설정</Typography>
                                    <input
                                        type="text"
                                        id="interest"
                                        onChange={valueChangeHandler}
                                        defaultValue="2"
                                    ></input>
                                    <input
                                        type="text"
                                        id="interestTime"
                                        onChange={valueChangeHandler}
                                        defaultValue="5"
                                    ></input>
                                    <div className={classes.selectBox}>
                                        <select
                                            className={classes.select}
                                            onChange={valueChangeHandler2}
                                        >
                                            <option value="시">시</option>
                                            <option value="분" selected>
                                                분
                                            </option>
                                            <option value="초">초</option>
                                        </select>
                                        <span className={classes.arrowIcon}>
                                            <img src="/images/down_blue.webp"></img>
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <div className={classes.buttonContainer}>
                                <div></div>
                                <Button
                                    className={classes.createClass}
                                    onClick={classCreate}
                                >
                                    <Typography>개설하기</Typography>
                                </Button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

/*
const Modal2: React.FC<any> = props => {

    const { open, close, header } = props;
    const [Value, setValue] = useState("");
    // 제출한 검색어 관리
    const [Keyword, setKeyword] = useState("");

    // 입력 폼 변화 감지하여 입력 값을 state에 담아주는 함수
    const keywordChange = (e: { preventDefault: () => void; target: { value: string }; }) => {
        e.preventDefault();
        setValue(e.target.value);
    }

    // 제출한 검색어 state에 담아주는 함수
    const submitKeyword = (e: { preventDefault: () => void; }) => {
    e.preventDefault();
    setKeyword(Value);
    }

    // 검색어를 입력하지 않고 검색 버튼을 눌렀을 경우
    const valueChecker = () => {
        if (Value === "") {
            alert ("검색어를 입력해주세요.")
        }
    }
    console.log(open)
    return ( 
        <div className={open ? 'openModal modal' : 'modal'}>
            {open ? (
            <section>
                <header>
                    {header}
                    <button className="close" onClick={close}>
                    &times;
                    </button>
                </header>
                <main>
                <div id="map" style={{width:"500px", height:"400px"}}></div>
                </main>
                <footer>
                    <button className="close" onClick={close}>close</button>
                </footer>
            </section>
            ) : null}
            <div className="landing-page__inner">
                <div className="search-form-container">
                    <form className="search-form" onSubmit={ submitKeyword }>
                        <label htmlFor="place" className="form__label">
                            <input type="text" id="movie-title" className="form__input" name="place" onChange={ keywordChange } placeholder="검색어를 입력해주세요. (ex: 강남 맛집)" required />
                            <div className="btn-box">
                                <input className="btn form__submit" type="submit" value="검색" onClick={ valueChecker }/>
                            </div>
                        </label>
                    </form>
                </div>
                <MapContainer searchKeyword={ Keyword }/>  
            </div>                              
        </div>
    )
}
*/
const Modal: React.FC<any> = (props) => {
    const { open, close, header, getAddress } = props;

    const [Keyword, setKeyword] = useState('');
    const handlePostCode = (data: any) => {
        let fullAddress = data.address;
        let extraAddress = '';

        if (data.addressType === 'R') {
            if (data.bname !== '') {
                extraAddress += data.bname;
            }
            if (data.buildingName !== '') {
                extraAddress +=
                    extraAddress !== ''
                        ? `, ${data.buildingName}`
                        : data.buildingName;
            }
            fullAddress += extraAddress !== '' ? ` (${extraAddress})` : '';
        }
        console.log(data);
        console.log(fullAddress);
        getAddress(fullAddress);
        close();
    };
    return (
        <div className={open ? 'openModal modal' : 'modal'}>
            {open ? (
                <section>
                    <header>
                        {header}
                        <button className="close" onClick={close}>
                            &times;
                        </button>
                    </header>
                    <main>
                        <DaumPostcode onComplete={handlePostCode} />
                    </main>

                    <footer>
                        <button className="close" onClick={close}>
                            close
                        </button>
                    </footer>
                </section>
            ) : null}
            <MapContainer searchKeyword={Keyword} />
        </div>
    );
};

export default SubAdminCreateClass;
